import styled from "styled-components";
import { fonts, colors } from "./variables.js";

export const H1 = styled.h1`
   font-size: 3rem;
   font-family: ${fonts.main};
   font-weight: 700;
   color: ${colors.primary1};
   text-align: ${props => (props.center ? "center" : "left")};

   @media (max-width: 1000px) {
      font-size: 2.6rem;
   }

   @media (max-width: 900px) {
      font-size: 3.2rem;
   }

   @media (max-width: 700px) {
      font-size: 2.8rem;
   }
   /*	@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : portrait)
*/
   @media only screen and (max-device-width: 800px) and (orientation: landscape) {
      font-size: 2.4rem;
   }

   @media (max-width: 500px) {
      font-size: 2.4rem;
   }
`;

export const H2 = styled.h2`
   font-size: 2.1rem;
   font-family: ${fonts.main};
   font-weight: 700;
   color: ${colors.primary1};
   text-align: ${props => (props.center ? "center" : "left")};

   @media (max-width: 1000px) {
      font-size: 1.9rem;
   }

   @media (max-width: 900px) {
      font-size: 2.1rem;
   }

   @media (max-width: 700px) {
      font-size: 1.9rem;
   }
   /*	@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : portrait)
*/
   @media only screen and (max-device-width: 800px) and (orientation: landscape) {
      font-size: 1.7rem;
   }

   @media (max-width: 500px) {
      font-size: 1.7rem;
   }
`;

export const H3 = styled.h3`
   font-size: 2rem;
   font-family: ${fonts.main};
   font-weight: 600;
   color: ${colors.primary1};
   text-align: ${props => (props.center ? "center" : "left")};

   @media (max-width: 1000px) {
      font-size: 2rem;
   }

   @media (max-width: 900px) {
      font-size: 2rem;
   }

   @media (max-width: 700px) {
      font-size: 1.8rem;
   }
   /*	@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : portrait)
*/
   @media only screen and (max-device-width: 800px) and (orientation: landscape) {
      font-size: 1.7rem;
   }

   /* @media (max-width: 500px) {
      font-size: 1.6rem;
   } */
`;
